import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ChangeDetectorRef } from '@angular/core';

import { PresentationSelectorModalComponent } from '../presentation-selector-modal/presentation-selector-modal.component';
import { FolderService } from 'src/app/shared/services/folder.service';
import { ScrollingListService } from 'src/app/ajs-upgraded-providers';
import { PresentationApiService } from 'src/app/api/services/presentation-api.service';
import { FoldersApiService } from 'src/app/api/services/folders-api.service';
import { MoveFolderDialogService } from 'src/app/components/folders/services/move-folder-dialog.service';

@Component({
    selector: 'presentation-multi-selector',
    templateUrl: './presentation-multi-selector.component.html',
    styleUrls: ['./presentation-multi-selector.component.scss'],
    standalone: false,
    providers: [
      MoveFolderDialogService
    ]
})
export class PresentationMultiSelectorComponent extends PresentationSelectorModalComponent {

  constructor(
    dialogRef: MatDialogRef<PresentationMultiSelectorComponent>,
    changeDetectorRef: ChangeDetectorRef,
    scrollingListService: ScrollingListService,
    presentationApiService: PresentationApiService,
    public folderService: FolderService,
    public selectFolderDialogService: MoveFolderDialogService
  ) {
    super(dialogRef, changeDetectorRef, scrollingListService, presentationApiService);
    
    this.selectFolderDialogService.initTree('Presentation');
    this.selectFolderDialogService.updateFolderList({
      kind: 'Presentation',
      folderId: '',
      parentId: '',
    });
  }
  
  areAllPresentationsSelected(): boolean {
    const presentations = this.presentations.items.list;
    return presentations.length > 0 && presentations.every(presentation => presentation.selected);
  }

  selectAll(checked: boolean) {
    const allSelected = this.areAllPresentationsSelected();
    this.presentations.items.list.forEach(presentation => {
      if (allSelected) {
        presentation.selected = false;
      } else {
        presentation.selected = true;
      }
    });
  }

  add() {
    this.dialogRef.close(this.presentations.getSelected());
  }

  onFolderClicked(folderId: string) {
    this.selectFolderDialogService.updateFolderList({
      kind: 'Presentation',
      parentId: folderId,
      search: undefined,
      folderId: '',
    });
    this.search.folderId = folderId;
    this.presentations.doSearch();
  }

  get items() {
    let items = [];
    let folders = this.selectFolderDialogService.folders();
    
    if (this.presentations) {
      items = this.presentations.items?.list?.filter(
        (item) => this.folderService.showFolderItem(
          this.selectFolderDialogService.currentParentFolderId
          || FoldersApiService.ROOT_FOLDER_ID,
          item.folderId
        )
      ) || [];
    }
    return [...folders, ...items];
  }

  get isLoading() {
    return this.presentations.loadingItems || this.selectFolderDialogService.loading();
  }
}
